<template>
  <div class="relative w-full min-h-full flex flex-col gap-5">
    <!-- Manchas de color difuminadas — mismo tratamiento que Dashboard / Inicio
         de Operaciones, para que el vidrio de las cards tenga algo de color
         detrás. -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none -z-10" aria-hidden="true">
      <div class="absolute -top-20 -left-16 w-80 h-80 rounded-full opacity-40 dark:opacity-25 blur-[70px]" style="background: radial-gradient(circle, #6ee7b7 0%, transparent 70%)"></div>
      <div class="absolute bottom-[-100px] right-[-80px] w-96 h-96 rounded-full opacity-40 dark:opacity-25 blur-[70px]" style="background: radial-gradient(circle, #fca5a5 0%, transparent 70%)"></div>
    </div>

    <!-- Cards de descarga -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <ReportDownloadCard
        title="Vehículos aprobados"
        description="Ingresos cargados y aprobados correctamente"
        icon="mdi-truck-check-outline"
        variant="approved"
        filename-prefix="reporte-aprobados"
        :download-fn="getApprovedReport"
      />

      <ReportDownloadCard
        title="Vehículos desaprobados"
        description="Ingresos que resultaron desaprobados"
        icon="mdi-car-off"
        variant="disapproved"
        filename-prefix="reporte-desaprobados"
        :download-fn="getDisapprovedReport"
      />
    </div>
  </div>
</template>

<script setup>
import ReportDownloadCard from '../components/ReportDownloadCard.vue'
import { getApprovedReport, getDisapprovedReport } from '../services/ReportsService'
</script>
